module.exports = __webpack_public_path__ + "img/marco.a4f644b.webp";